import {
  UT_FAILURE,
  UT_PENDING,
  UT_SUCCESS,
  UST_SUCCESS,
  UST_FAILURE,
  UST_PENDING,
} from './constants'

const initialState = {
  templates: [],
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UT_PENDING:
    case UST_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case UT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        templates: action.payload,
      }
    case UST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        templates: action.payload,
      }
    case UT_FAILURE:
    case UST_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
